// extracted by mini-css-extract-plugin
module.exports = {"selectableBorder":"selectableBorder_-wEBpQf0EC","selected":"selected_3l3bowiFsW"};